import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

// Registrar módulos (obligatorio en Chart.js v4)
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// Helpers
const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

const cssVar = (name, fallback) => {
  if (typeof window === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
};

/**
 * Props:
 * - labels & values  -> uso directo
 * - o rows           -> agrega sumando por ProductLineDesc; usa campo FreightAmt (ajústalo si tu backend usa otro)
 * - height           -> alto del canvas (px)
 */
export default function FreightByLoBBar(props) {
  const { labels, dataValues } = useMemo(() => {
    if (props.labels && props.values) {
      return { labels: props.labels, dataValues: props.values };
    }
    const acc = {};
    const rows = props.rows || [];
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i] || {};
      const lob = r.ProductLineDesc ? String(r.ProductLineDesc) : "SIN_CATEGORIA";
      const freight = Number(r.FreightAmt || r.Flete || r.Freight || 0); // ajusta el nombre del campo
      acc[lob] = (acc[lob] || 0) + freight;
    }
    const keys = Object.keys(acc);
    return { labels: keys, dataValues: keys.map((k) => acc[k]) };
  }, [props.labels, props.values, props.rows]);

  const color = cssVar("--ml-accent", "#3aa0ff");
  const color2 = cssVar("--ml-info", "#30d5c8");

  const data = {
    labels,
    datasets: [
      {
        label: "Flete",
        data: dataValues,
        backgroundColor: color,
        borderColor: color2,
        borderWidth: 1,
        borderRadius: 8,
        barThickness: 24,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${fmtUSD(Number(ctx.parsed.y))}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { color: "#a8b3c7" } },
      y: {
        grid: { color: "rgba(255,255,255,.08)" },
        ticks: { color: "#a8b3c7", callback: (v) => fmtUSD(Number(v)) },
      },
    },
  };

  return (
    <div style={{ height: props.height || 300 }}>
      <Bar data={data} options={options} />
    </div>
  );
}
